import { Link } from 'react-router-dom';
import { PageContainer } from '@/components/PageContainer';
import { buttonClasses } from '@/components/ui/button-styles';

export function NotFoundPage() {
  return (
    <PageContainer width="narrow">
      <div className="rounded-2xl border border-line bg-white p-10 text-center shadow-soft">
        <p className="text-brand-gradient text-5xl font-extrabold">404</p>
        <h1 className="mt-4 text-xl font-bold text-ink">We could not find that page</h1>
        <p className="mt-2 text-sm text-slate-500">
          The link may be out of date, or the page may have moved.
        </p>
        <Link to="/" className={buttonClasses('primary', 'md', 'mt-6')}>
          Back home
        </Link>
      </div>
    </PageContainer>
  );
}
